import flashMessenger from './FlashMessenger';
import crApi from "./CrApi";
import securityService from "./SecurityService";

class CreateDatabaseHelper {
    public modalVisible = false;
    public isCreatingDb = false;
    public newDbName = '';
    public dbId = null;

    public create() {
        this.modalVisible = true;
        this.newDbName = '';
    };

    public async createDb() {
        this.isCreatingDb = true;
        const response = await crApi.requestV2('database/create/',{databaseName: this.newDbName, website_token: securityService.getToken()});
        if (response.status == 1) {
            this.dbId = response.databaseId;
            flashMessenger.toastById('DB_CREATED', 'success');
        } else {
            flashMessenger.toastById(response.error, 'error');
        }
        this.isCreatingDb = false;
        this.modalVisible = false;
    };
}

export default new CreateDatabaseHelper();